import React from 'react'
import ReactJoyride, { Step } from 'react-joyride'
import { handleJoyrideCallback } from 'helpers/tutorials'
import { themeConfig } from 'config'

type Props = {
  showTutorial: boolean
  steps: Step[]
  onCloaseTutorial: () => void
}

const AppTutorial = (props: Props) => {
  const { showTutorial, steps, onCloaseTutorial } = props
  return (
    <ReactJoyride
      callback={(data: any) => handleJoyrideCallback(data, onCloaseTutorial)}
      continuous
      hideCloseButton
      run={showTutorial}
      scrollToFirstStep
      showProgress
      showSkipButton
      steps={steps}
      disableOverlayClose={true}
      styles={{
        options: {
          primaryColor: themeConfig.colors.primary,
          width: '100%',
          zIndex: 10000,
        },
      }}
    />
  )
}

export default AppTutorial
